module.exports = __webpack_public_path__ + "img/mobile-1.b2ad7188.jpg";